import type { BadgeKanbanStageStatusColor } from '@shared/ui/kanban'

import { TasksKanbanStage } from '@brighterly/lib-core-types/tasks-kanban/enums'

export const TASKS_KANBAN_STAGE_COLOR: Record<TasksKanbanStage, BadgeKanbanStageStatusColor> = {
  [TasksKanbanStage.Backlog]: 'gray',
  [TasksKanbanStage.Todo]: 'blue',
  [TasksKanbanStage.InProgress]: 'blue',
  [TasksKanbanStage.Waiting]: 'orange',
  [TasksKanbanStage.Resolved]: 'emerald',
  [TasksKanbanStage.Cancelled]: 'red',
}
